import { createPostAsyncSlice } from '@sonar-software/xuder';
import { postMcpOAuthApprove } from '@api';

export const securityMcpOAuthApprovePostAsyncSlice = createPostAsyncSlice({
	name: 'SecurityMcpOAuthApprove',
	receive: true,
	request: true,
	requestHandler: postMcpOAuthApprove
});
